import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import styles from './DatasetDescription.css';
const DatasetDescription = ({ items, }) => (_jsx("ul", Object.assign({ className: styles.list, "aria-label": "datasetDescriptionList" }, { children: items.map((item) => (_jsx("li", Object.assign({ className: styles.item, "aria-label": "datasetDescriptionItem" }, { children: item }), item))) }), void 0));
export default memo(DatasetDescription);
